import { render, staticRenderFns } from "./FittingList.vue?vue&type=template&id=0019370b&"
import script from "./FittingList.vue?vue&type=script&lang=js&"
export * from "./FittingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports